var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferenceEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8072 0.528816C12.304 0.0320614 13.1094 0.0320614 13.6061 0.528816C14.1029 1.02557 14.1029 1.83097 13.6061 2.32772L6.40232 9.53152C6.04366 9.89018 5.60129 10.1538 5.11518 10.2986L3.73662 10.7093C3.54623 10.766 3.36894 10.5887 3.42565 10.3983L3.8363 9.01976C3.9811 8.53365 4.24474 8.09128 4.6034 7.73262L10.6624 1.67363L11.8072 0.528816ZM2.05957 3.58737C2.05957 3.10123 2.45366 2.70714 2.9398 2.70714H6.3814C6.79561 2.70714 7.1314 2.37136 7.1314 1.95714C7.1314 1.54293 6.79561 1.20714 6.3814 1.20714H2.9398C1.62524 1.20714 0.55957 2.27281 0.55957 3.58737V11.1951C0.55957 12.5097 1.62524 13.5753 2.9398 13.5753H10.5475C11.8621 13.5753 12.9278 12.5097 12.9278 11.1951V7.75352C12.9278 7.33931 12.592 7.00352 12.1778 7.00352C11.7636 7.00352 11.4278 7.33931 11.4278 7.75352V11.1951C11.4278 11.6813 11.0337 12.0753 10.5475 12.0753H2.9398C2.45366 12.0753 2.05957 11.6813 2.05957 11.1951V3.58737Z",
    fill: "#BE5400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceEdit);
export default __webpack_public_path__ + "static/media/reference-edit.e3e242379a3342359197285841a9ad9d.svg";
export { ForwardRef as ReactComponent };